/* action types */
export const types = {
	ONBOARDING_SET_PAGES: 'ONBOARDING/SET_PAGES',
	ONBOARDING_NEXT_PAGE: 'ONBOARDING/NEXT_PAGE',
	ONBOARDING_PREV_PAGE: 'ONBOARDING/PREV_PAGE',
	ONBOARDING_SPEC_PAGE: 'ONBOARDING/SPEC_PAGE',
};

/* initial state */
const initialState = {
	Pages: [],
	Page: null,
	pageNo: 1,
	firstPage: true,
	lastPage: false,
	finished: false,
};

/* reducer */
export default (state = initialState, action) => {
	const {Pages, pageNo} = state;

	switch (action.type) {
		case types.ONBOARDING_SET_PAGES:
			return {...state, pageNo: 1, Page: action.pages[0], Pages: action.pages,
							firstPage: true, lastPage: false, finished: false};

		case types.ONBOARDING_NEXT_PAGE:
			const nextPageNo = pageNo >= 1 && pageNo < Pages.length ? pageNo + 1 : pageNo;
			return {...state, pageNo: nextPageNo, Page: Pages[nextPageNo - 1],
						  firstPage: false, lastPage: nextPageNo === Pages.length, finished: pageNo === Pages.length};

		case types.ONBOARDING_PREV_PAGE:
			const prevPageNo = pageNo > 1 ? pageNo - 1 : pageNo;
			return {...state, pageNo: prevPageNo, Page: Pages[prevPageNo - 1],
							firstPage: prevPageNo === 1, lastPage: false, finished: false};

		case types.ONBOARDING_SPEC_PAGE:
			const specPageNo = action.pageNo >= 1 && action.pageNo <= Pages.length ? action.pageNo : pageNo;
			return {...state, pageNo: specPageNo, Page: Pages[specPageNo - 1],
							firstPage: specPageNo === 1, lastPage: specPageNo === Pages.length, finished: false};

		default:
			return state;
	}
}

/* action creators */
export const actions = {
	setPages: pages => ({type: types.ONBOARDING_SET_PAGES, pages}),
	nextPage: () => ({type: types.ONBOARDING_NEXT_PAGE}),
	prevPage: () => ({type: types.ONBOARDING_PREV_PAGE}),
	specPage: pageNo => ({type: types.ONBOARDING_SPEC_PAGE, pageNo}),
};


// WEBPACK FOOTER //
// ./src/components/handlers/onboarding/onboardingHandler.jsx